import { connect } from '@ardoq/rxbeach';
import { SettingsBar, SettingsBarProps } from '@ardoq/settings-bar';
import {
  leftPaneSettingsBarState$,
  rightPaneSettingsBarState$,
} from './viewPaneSettingsBar$';

const PaneSettingsBar = ({
  viewId,
  leftMenu,
  rightMenu,
  customToolbarStyles,
  i18nLocale,
}: SettingsBarProps) => {
  if (leftMenu.length === 0 && rightMenu.length === 0) {
    return null;
  }

  return (
    <SettingsBar
      viewId={viewId}
      leftMenu={leftMenu}
      rightMenu={rightMenu}
      customToolbarStyles={customToolbarStyles}
      i18nLocale={i18nLocale}
    />
  );
};

export const LeftPaneSettingsBar = connect(
  PaneSettingsBar,
  leftPaneSettingsBarState$
);

export const RightPaneSettingsBar = connect(
  PaneSettingsBar,
  rightPaneSettingsBarState$
);
